export default {
  badge: 'ਬੈਜ',
  close: 'ਬੰਦ ਕਰੋ',
  dataIterator: {
    noResultsText: 'ਕੋਈ ਮੇਲ ਖਾਂਦਾ ਰਿਕਾਰਡ ਨਹੀਂ ਮਿਲਿਆ',
    loadingText: 'ਆਈਟਮਾਂ ਲੋਡ ਕੀਤੀਆਂ ਜਾ ਰਹੀਆਂ ਹਨ...',
  },
  dataTable: {
    itemsPerPageText: 'ਪ੍ਰਤੀ ਪੰਨਾ ਕਤਾਰਾਂ:',
    ariaLabel: {
      sortDescending: 'ਘਟਦੇ ਕ੍ਰਮ ਵਿੱਚ ਕ੍ਰਮਬੱਧ।',
      sortAscending: 'ਵੱਧਦੇ ਕ੍ਰਮ ਵਿੱਚ ਕ੍ਰਮਬੱਧ।',
      sortNone: 'ਕ੍ਰਮਬੱਧ ਨਹੀਂ।',
      activateNone: 'ਛਾਂਟੀ ਨੂੰ ਹਟਾਉਣ ਲਈ ਕਿਰਿਆਸ਼ੀਲ ਕਰੋ।',
      activateDescending: 'ਘਟਦੇ ਕ੍ਰਮ ਨੂੰ ਕ੍ਰਮਬੱਧ ਕਰਨ ਲਈ ਕਿਰਿਆਸ਼ੀਲ ਕਰੋ।',
      activateAscending: 'ਵਧਦੇ ਕ੍ਰਮ ਨੂੰ ਕ੍ਰਮਬੱਧ ਕਰਨ ਲਈ ਕਿਰਿਆਸ਼ੀਲ ਕਰੋ।',
    },
    sortBy: 'ਦੇ ਨਾਲ ਕ੍ਰਮਬੱਧ',
  },
  dataFooter: {
    itemsPerPageText: 'ਆਈਟਮਾਂ ਪ੍ਰਤੀ ਪੰਨਾ:',
    itemsPerPageAll: 'ਸਾਰੇ',
    nextPage: 'ਅਗਲਾ ਪੰਨਾ',
    prevPage: 'ਪਿਛਲੇ ਸਫ਼ੇ',
    firstPage: 'ਪਹਿਲਾ ਪੰਨਾ',
    lastPage: 'ਆਖਰੀ ਪੰਨਾ',
    pageText: '{2} ਵਿੱਚੋਂ {0}-{1}',
  },
  datePicker: {
    itemsSelected: '{0} ਚੁਣਿਆ ਗਿਆ',
    nextMonthAriaLabel: 'ਅਗਲਾ ਮਹੀਨਾ',
    nextYearAriaLabel: 'ਅਗਲੇ ਸਾਲ',
    prevMonthAriaLabel: 'ਪਿਛਲਾ ਮਹੀਨਾ',
    prevYearAriaLabel: 'ਪਿਛਲੇ ਸਾਲ',
  },
  noDataText: 'ਕੋਈ ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ',
  carousel: {
    prev: 'ਪਿਛਲਾ ਵਿਜ਼ੂਅਲ',
    next: 'ਅਗਲਾ ਵਿਜ਼ੁਅਲ',
    ariaLabel: {
      delimiter: 'ਕੈਰੋਸੇਲ ਸਲਾਈਡ {1} ਵਿੱਚੋਂ {0}',
    },
  },
  calendar: {
    moreEvents: '{0} ਹੋਰ',
  },
  fileInput: {
    counter: '{0} ਫ਼ਾਈਲਾਂ',
    counterSize: '{0} ਫ਼ਾਈਲਾਂ (ਕੁੱਲ {1})',
  },
  timePicker: {
    am: 'ਏ.ਐੱਮ',
    pm: 'ਪੀ.ਐੱਮ',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'ਪੰਨਾ ਨੈਵੀਗੇਸ਼ਨ',
      next: 'ਅਗਲਾ ਪੰਨਾ',
      previous: 'ਪਿਛਲੇ ਸਫ਼ੇ',
      page: `ਪੰਨਾ {0} 'ਤੇ ਜਾਓ`,
      currentPage: 'ਮੌਜੂਦਾ ਪੰਨਾ, ਪੰਨਾ {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: '{1} ਵਿੱਚੋਂ {0} ਰੇਟਿੰਗ',
    },
  },
};
